// address bar sorting for desktop -------------------
document.addEventListener("DOMContentLoaded", function () {
  // Get all div elements with class 'div-one'
  var divs = document.querySelectorAll("#sidebar-for-desktop .div-one");
  var container;
  // Convert NodeList to an array for sorting
  var divsArray = Array.from(divs);

  // Sort divs based on whether they contain the heading 'Default'
  divsArray.sort(function (a, b) {
    var hasDefaultA =
      a.querySelector("h3") &&
      a.querySelector("h3").textContent.trim() === "Default";
    var hasDefaultB =
      b.querySelector("h3") &&
      b.querySelector("h3").textContent.trim() === "Default";

    // Move divs with 'Default' heading to the beginning
    if (hasDefaultA && !hasDefaultB) {
      return -1;
    } else if (!hasDefaultA && hasDefaultB) {
      return 1;
    } else {
      // Maintain the original order for other divs
      return 0;
    }
  });

  // Clear the existing content in the parent container
  if (divs[0]) {
    container = divs[0].parentNode;
  }
  if (container) {
    container.innerHTML = "";

    // Append the sorted divs back to the container
    divsArray.forEach(function (div) {
      container.appendChild(div);
    });
  }
});

// address bar sorting for mobile ------------------

document.addEventListener("DOMContentLoaded", function () {
  const sourceElement = document.querySelector('.mobile-facets__wrapper details summary');
    const targetElement = document.querySelector('form#FacetFiltersFormMobile details summary');

    if (sourceElement && targetElement) {
        sourceElement.addEventListener('click', function() {
          if(!targetElement.closest('[open]')){
            targetElement.click();
          }
            
        });
    }
  // Get all div elements with class 'div-one'
  var divs = document.querySelectorAll("#sidebar-for-mobile .div-one");
  var container;
  // Convert NodeList to an array for sorting
  var divsArray = Array.from(divs);

  // Sort divs based on whether they contain the heading 'Default'
  divsArray.sort(function (a, b) {
    var hasDefaultA =
      a.querySelector("h3") &&
      a.querySelector("h3").textContent.trim() === "Default";
    var hasDefaultB =
      b.querySelector("h3") &&
      b.querySelector("h3").textContent.trim() === "Default";

    // Move divs with 'Default' heading to the beginning
    if (hasDefaultA && !hasDefaultB) {
      return -1;
    } else if (!hasDefaultA && hasDefaultB) {
      return 1;
    } else {
      // Maintain the original order for other divs
      return 0;
    }
  });

  // Clear the existing content in the parent container
  if (divs[0]) {
    container = divs[0].parentNode;
    container.innerHTML = "";

    // Append the sorted divs back to the container
    divsArray.forEach(function (div) {
      container.appendChild(div);
    });
  }
});

let filter_hide = document.querySelector(".facet-filters");

if (filter_hide) {
  const brand_current = window.location.href;
  console.log(brand_current);
  let filterURL = localStorage.showFilter;
  if(location.pathname == filterURL){
    let filter_hide = document.querySelector(".facet-filters");
    let model_filter = document.querySelector('.small-hide .facets__disclosure');
    if (model_filter) {
      model_filter.classList.add('model-filters');
    }

    filter_hide.style.display = "none";
  }
  else{
    document.querySelector('.mobile-facets__wrapper').style.display = "none";
    let filter_hide = document.querySelector(".facet-filters");
    let model_filter = document.querySelector('.small-hide .facets__disclosure');
    if (model_filter) {
      model_filter.classList.remove('model-filters');
    }

    filter_hide.style.display = "none";
  }
  if (filter_hide && brand_current.includes("hide=true")) {
    let filter_hide = document.querySelector(".facet-filters");
    let model_filter = document.querySelector('.small-hide .facets__disclosure');
    if (model_filter) {
      model_filter.classList.add('model-filters');
    }

    filter_hide.style.display = "none";
  }
}

window.addEventListener("popstate", function (event) {
    location.reload();
});